import { Injectable, Inject } from '@angular/core';
import * as signalR from "@aspnet/signalr";
import { ConfirmationService } from 'primeng/api';
import { CheckinRequest } from '../../domain/checkinRequest';
import { DashboardService } from '../../modules/dashboard/shared/dashboard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  baseUrl: string;
  constructor(private confirmationService: ConfirmationService, private dashboardService: DashboardService, private router: Router,
    private route: ActivatedRoute, @Inject('BASE_URL') baseUrl: string, private modalService: BsModalService) {
    this.baseUrl = baseUrl;
  }

  isResponded: boolean = false;
  hideDialog: boolean = false;
  private hubConnection: signalR.HubConnection

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.baseUrl + 'statusHub')
      .build();

    this.hubConnection
      .start()
      .then(() => { console.log('Hub Connection started'); console.log(this.hubConnection); })
      .catch(err => console.log('Error while starting hub connection: ' + err))
  }

  public addDataListener = () => {
    this.hubConnection.on('TestSignal', (name, message) => {
      alert(name + " : " + message);
    });
  }

  public addUserMessageListener = (userId) => {
    console.log("Add user listener: " + userId);
    this.hubConnection.on(userId, (type, info) => {
      if (type == "CheckinResponse") {
        this.isResponded = true;
        alert(info.message);
      }
      if (type == "CheckinRequest") {
        this.isResponded = false;
        this.hideDialog = false;
        console.log(info);
        //If user not responding in 30 sec checkin automatically
        setTimeout(() => {
          console.log("Response Timeout..");
          if (!this.isResponded) {
            this.checkinResponse(info.requestId, false, true);
          }
        }, 25000);
        setTimeout(() => {
          this.confirmationService.confirm({
            message: info.message + " Do you want to check in the accounting and grant the user access?",
            header: "Access Request",
            key: "signal",
            accept: () => {
              this.isResponded = true;
              this.checkinResponse(info.requestId, true, true);
            },
            reject: () => {
              this.isResponded = true;
              this.checkinResponse(info.requestId, true, false);
            }
          });
        }, 30);
      }
    });
  }

  checkinResponse(id, isResponded, isAgreed, redirect = true) {
    var req = new CheckinRequest();
    req.id = id;
    req.isResponded = isResponded;
    req.isAgreed = isAgreed;

    this.dashboardService.sendCheckinResponse(req).subscribe(result => {
      if (isResponded)
        alert(result.message);
      if (isAgreed && redirect) {
        this.modalService.hide(1);
        this.router.navigateByUrl("/dashboard", { skipLocationChange: false });
      }
    }, error => console.error(error));
  }

  public removeUserMessageListener = (userId) => {
    this.hubConnection.off(userId);
  }

  public sendToAll(name, message) {
    this.hubConnection.invoke("Send", name, message).catch(function (err) {
      return console.error(err.toString());
    });
  }

  public send(name, message) {
    this.hubConnection.invoke("Send", name, message).catch(function (err) {
      return console.error(err.toString());
    });
  }
}
